export default __webpack_public_path__ + "static/media/cumin.a4b748a4.png";